/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Failure reason if job failed
 * @export
 * @interface FailureReason
 */
export interface FailureReason {
}

/**
 * Check if a given object implements the FailureReason interface.
 */
export function instanceOfFailureReason(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FailureReasonFromJSON(json: any): FailureReason {
    return FailureReasonFromJSONTyped(json, false);
}

export function FailureReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureReason {
    return json;
}

export function FailureReasonToJSON(value?: FailureReason | null): any {
    return value;
}

